module.exports = "<span ng-click=\"vm.goBackHome()\" class=\"fa fa-home logo-house fa-lg\"> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-home-icon/dv-home-icon.html
// module id = NDtb
// module chunks = 0